interface SummaryCardItem {
    label: string;
    value: number;
    description: string;
    tone: 'primary' | 'neutral' | 'warm' | 'soft';
}

const toneClasses = {
    primary:
        'border-[#dbe9d6] bg-gradient-to-b from-[#f3fded] to-white dark:border-white/10 dark:from-[#112116] dark:to-black',
    neutral:
        'border-gray-200 bg-gradient-to-b from-white to-gray-50 dark:border-white/10 dark:from-[#151515] dark:to-black',
    warm: 'border-[#ece3c1] bg-gradient-to-b from-[#fffaf0] to-white dark:border-white/10 dark:from-[#2b2417] dark:to-black',
    soft: 'border-[#dfe6df] bg-gradient-to-b from-[#f7faf8] to-white dark:border-white/10 dark:from-[#182019] dark:to-black',
};

const SubscriptionsSummaryCards = ({
    loading,
    items,
}: {
    loading?: boolean;
    items: SummaryCardItem[];
}) => {
    if (loading) {
        return (
            <div className='grid grid-cols-1 gap-4 md:grid-cols-2 xl:grid-cols-4'>
                {Array.from({ length: 4 }).map((_, index) => (
                    <div
                        key={index}
                        className='rounded-2xl border border-gray-200 dark:border-white/10 bg-white dark:bg-black p-5 animate-pulse'
                    >
                        <div className='h-3 w-24 rounded bg-gray-200 dark:bg-gray-700' />
                        <div className='mt-4 h-9 w-24 rounded bg-gray-200 dark:bg-gray-700' />
                        <div className='mt-3 h-3 w-36 rounded bg-gray-200 dark:bg-gray-700' />
                    </div>
                ))}
            </div>
        );
    }

    return (
        <div className='grid grid-cols-1 gap-4 md:grid-cols-2 xl:grid-cols-4'>
            {items.map((item) => (
                <div
                    key={item.label}
                    className={`rounded-2xl border p-5 shadow-sm ${toneClasses[item.tone]}`}
                >
                    <p className='text-sm font-medium text-gray-600 dark:text-gray-300'>
                        {item.label}
                    </p>
                    <p className='mt-4 text-3xl font-semibold tracking-tight text-[#101010] dark:text-primary-darkMode'>
                        {item.value.toLocaleString()}
                    </p>
                    <p className='mt-2 text-sm text-gray-500 dark:text-gray-400'>
                        {item.description}
                    </p>
                </div>
            ))}
        </div>
    );
};

export default SubscriptionsSummaryCards;
